export enum GoogleAnalyticsEvents {
  ErrorBoundary = 'error_boundary',
  SubmitXRayForm = 'submit_xray_form',
  SaveXRayHistory = 'save_xray_history',
}
